import React from 'react';
import { Register } from '../factory';
import DySelect from './dy-select';

@Register({ name: 'dy-radio' })
class DyRadio extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange = value => {
        this.props.onChange && this.props.onChange(value);
    };

    render() {
        let { className, name, options, value, selectType } = this.props;

        if(!!selectType) {
            return <DySelect {...this.props}/>
        }

        if (!options) {
            return '';
        }
        return (
            <div className={`dy-fm-item-radio-con dy-fm-item ${className ? className : ''}`}>
                {options.map(option => (
                    <div className={`dy-fm-item-radio ${Number(option.seq) === value ? 'checked' : ''}`} key={option.content}>
                        <label className="dy-fm-item-radio-ct">
                            <input
                                type="radio"
                                name={name}
                                value={Number(option.seq)}
                                onClick={() => this.handleChange(Number(option.seq))}
                            />
                            <span className="dy-fm-item-icon"></span>
                            {option.content}
                        </label>
                    </div>
                ))}
            </div>
        );
    }
}

export default DyRadio;
